import { render } from "./ProfileDataInProfilesListView.vue?vue&type=template&id=bccacada&ts=true"
import script from "./ProfileDataInProfilesListView.vue?vue&type=script&lang=ts"
export * from "./ProfileDataInProfilesListView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__